<!-- 商品管理-商品库 -->

<template>
  <div class="main" v-loading="loading">
    <!-- 顶部搜索 -->
    <div class="s_wrapper">
      <el-cascader :options="cascaderOptions" placeholder="选择商品类目(二级)" v-model="categoryIds" @change="onSearch"
        :props="cascaderprops" collapse-tags clearable></el-cascader>
      <el-input class="s_input" placeholder="搜索商品名称" suffix-icon="el-icon-search" v-model="productName"
        :clearable="true" @change="onSearch"></el-input>
      <el-input class="s_input" placeholder="搜索商品条形码" suffix-icon="el-icon-search" v-model="barCode" :clearable="true"
        @change="onSearch"></el-input>
      <el-select v-model="shelfStatus" placeholder="选择上下架状态" @change="onSearch" clearable>
        <el-option v-for="item in shelfOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-button class="btn" plain type="primary" @click="batchChangeStatus('down')"
        :disabled="multipleSelection.length == 0">批量下架</el-button>
      <el-button class="btn" plain type="primary" @click="batchChangeStatus('up')"
        :disabled="multipleSelection.length == 0">批量上架</el-button>
      <el-button class="btn" plain type="primary" @click="downloadTemplate">下载模板</el-button>
      <el-button class="btn" type="primary" @click="importShow = true">批量上传</el-button>
      <el-button class="btn" type="primary" @click="handleView('none')">上传新商品</el-button>
    </div>

    <!-- 表格 -->
    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540" @selection-change="handleSelectionChange"
        ref="tableRef" row-key="id">
        <el-table-column type="selection" min-width="55"></el-table-column>
        <el-table-column label="序号" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column label="图片" width="110">
          <template slot-scope="scope">
            <span class="show_img" @click="previewImage(scope.row.picList)">查看图片</span>
          </template>
        </el-table-column>
        <el-table-column prop="brand" label="品牌" show-overflow-tooltip min-width="180"></el-table-column>
        <el-table-column prop="barCode" label="商品条形码" show-overflow-tooltip min-width="180"></el-table-column>
        <el-table-column prop="productName" label="商品名称" show-overflow-tooltip min-width="180"></el-table-column>
        <el-table-column prop="productType" label="商品类型" show-overflow-tooltip min-width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.productType == 1">免费领</span>
            <span v-if="scope.row.productType == 2">优惠品</span>
            <span v-if="scope.row.productType == 3">热销品</span>
          </template>
        </el-table-column>
        <el-table-column prop="specs" label="规格" show-overflow-tooltip min-width="120"></el-table-column>
        <el-table-column prop="categoryName" label="分类" show-overflow-tooltip min-width="200"></el-table-column>
        <el-table-column prop="factoryName" label="厂家" show-overflow-tooltip min-width="120"></el-table-column>
        <el-table-column prop="validityPeriod" label="保质期(天)" show-overflow-tooltip min-width="100"></el-table-column>
        <el-table-column prop="salePrice" label="售价(元)" show-overflow-tooltip min-width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.salePrice.toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="上下架状态" header-align="center" align="center" min-width="100">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.switch" active-color="#4592e1" inactive-color="#E2E2E2"
              @change="changeStatus(scope.row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center" min-width="180" fixed="right">
          <template slot-scope="scope">
            <el-button size="small" class="btn" type="primary" plain @click="handleView(scope.row)">修改</el-button>
            <el-button size="small" class="btn" type="" plain @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
      layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>

    <el-image-viewer v-if="showViewer" :on-close="() => {
      showViewer = false
    }
      " :url-list="imgList"></el-image-viewer>

    <!-- 批量上传弹窗 -->
    <el-dialog title="批量上传" :visible.sync="importShow" :before-close="onImportCancel">
      <el-form label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="上传附件" required>
              <el-upload :action="apiBaseUrl" :headers="apiHeaders" :file-list="importFiles" accept=".xlsx,.xls"
                :on-change="beforeUpload" :auto-upload="false" :limit="1" :on-exceed="handleExceed"
                :on-remove="handleRemove">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip" style="color: red">提示：只能上传"xlsx"、"xls"文件，且不超过5MB</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="onImportCancel">取 消</el-button>
        <el-button type="primary" @click="submitFormImport('importRuleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {
    "el-image-viewer": () => import("element-ui/packages/image/src/image-viewer"),
  },
  data() {
    return {
      loading: false,
      categoryIds: "", // 搜索分类
      cascaderOptions: [],
      productName: "", // 搜索商品名称
      barCode: "", // 搜索商品条形码
      shelfStatus: "", // 是否上架
      shelfOptions: [{
        value: "1",
        label: "上架",
      },
      {
        value: "0",
        label: "下架",
      },
      ],
      // 表格数据
      tableData: [],
      multipleSelection: [],
      cascaderprops: {
        checkStrictly: false,
        emitPath: false,
        multiple: true,
        value: "categoryId",
        label: "categoryName",
        children: "children",
      },
      // 图片预览
      showViewer: false,
      imgList: [],
      // 导入弹窗数据
      apiBaseUrl: this.$axios.defaults.baseURL + this.$api.importNewProductApply,
      apiHeaders: {
        token: this.$store.state.token,
      },
      importShow: false,
      importFiles: [], //文件列表
      // 分页
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.selectProductList()
    this.getCategoryList()
  },
  methods: {
    // 列表
    selectProductList() {
      this.loading = true
      this.$axios
        .post(this.$api.selectProductList, {
          categoryIdList: this.categoryIds.length == 0 ? null : this.categoryIds,
          productName: this.productName || null,
          barCode: this.barCode || null,
          saleStatus: this.shelfStatus || null,
          page: this.currentPage,
          pageSize: this.pageSize,
        })
        .then(res => {
          if (res.code == 100) {
            this.tableData = res.result.list.map(e => {
              return {
                ...e,
                switch: e.saleStatus == 1 ? true : false
              }
            }) || []
            this.totalItemsCount = res.result.totalCount
            this.loading = false
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },
    getCategoryList() {
      this.$axios
        .get(this.$api.getCategoryList, {
          params: {
            page: 1,
            pageSize: 9999,
          },
        })
        .then(res => {
          if (res.code == 100) {
            this.cascaderOptions = res.result.list
          }
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    // 模板下载
    downloadTemplate() {
      const link = document.createElement("a")
      link.style.display = "none"
      link.href = "https://health.ganmiaoedu.com/files/excel/养长福商品批量导入模版.xlsx"
      link.download = "批量申请模版.xlsx"
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    // 导入弹窗关闭
    onImportCancel() {
      this.importShow = false
      this.importFiles = []
    },
    beforeUpload(file) {
      const suffixArr = ["xlsx", "xls"]
      const maxSize = 1024 * 1024 * 5
      if (!suffixArr.includes(file.name.split(".").pop())) {
        this.$message.error(`只能上传"xlsx"、"xls"文件`)
        this.importFiles = []
        return false
      }
      if (file.size > maxSize) {
        this.$message.error("附件不能超过5M")
        this.importFiles = []
        return false
      }
      this.importFiles.push(file.raw)
    },
    handleExceed() {
      this.$message.warning(`只能上传一个文件！`)
    },
    handleRemove() {
      this.importFiles = []
    },
    // 导入表单校验
    submitFormImport() {
      if (!this.importFiles || this.importFiles.length == 0) {
        return this.$message.warning("请先上传文件")
      }
      let parmas = new FormData()
      parmas.append("file", this.importFiles[0])
      this.$axios.post(this.$api.importNewProductApply, parmas).then(res => {
        if (res.code == 100) {
          this.$message.success("导入成功!")
          this.onImportCancel()
          this.selectProductList()
        }
      }).catch(err => {
        this.$message.error(err.desc)
      })
    },
    // 上传新商品
    handleView(row) {

      if (row == 'none') {
        this.$router.push('/product/detail/apply')
      } else {
        this.$router.push({
          path: '/product/detail/apply',
          query: {
            productId: row.productId
          }
        })
      }

    },
    // 选中
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 切换上下架
    changeStatus(row) {
      const originalSwitch = row.switch
      if (row.picList == null || row.picList.length == 0) {
        this.$message.warning("没有图片的商品不允许上架!")
        this.$set(row, "switch", !originalSwitch)
        // this.selectProductList()
        return
      }
      this.$confirm(`确定${row.switch ? "上架" : "下架"}该商品吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .post(this.$api.updateSaleStatus, {
              productIdList: [row.productId],
              saleStatus: row.switch ? 1 : 0,
            })
            .then(() => {
              this.$set(row, "switch", originalSwitch)
              this.$message.success("操作成功")
              this.selectProductList()
            })
            .catch(() => {
              this.$set(row, "switch", !originalSwitch)
              this.selectProductList()
            })
        })
        .catch(() => {
          this.$set(row, "switch", !originalSwitch)
          this.selectProductList()
        })
    },
    // 批量切换上下架状态
    batchChangeStatus(status) {
      if (this.multipleSelection.length === 0) {
        this.$message.warning("请先选择商品")
        return
      }
      const action = status === "up" ? "上架" : "下架"
      const ids = this.multipleSelection.map(item => item.productId)

      this.$confirm(`确定批量${action}这些商品吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .post(this.$api.updateSaleStatus, {
              productIdList: ids,
              saleStatus: status === "up" ? 1 : 0,
            })
            .then(() => {
              // 批量操作成功后更新商品列表状态
              this.multipleSelection.forEach(item => {
                item.switch = status === "up" ? true : false
              })
              this.$message.success(`批量${action}操作成功`)
              this.selectProductList()
            })
            .catch(() => {
              this.selectProductList()
            })
        })
        .catch(() => {
          // 取消操作时恢复之前的选择状态
          this.multipleSelection.forEach(item => {
            item.switch = !item.switch
          })
          this.selectProductList()
        })
    },
    handleDelete(row) {
      this.$confirm("是否要删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .get(this.$api.deleteProduct, {
              params: {
                productId: row.productId
              }
            })
            .then(res => {
              if (res.code == 100) {
                this.$message.success(res.desc)
              }
              this.selectProductList()
            })
            .catch(err => {
              this.$message.error(err.desc)
            })
        })
        .catch(() => {
          this.$message("取消删除！")
        })
    },
    // 清空
    clearData() {
      this.tableData = []
      this.currentPage = 1
    },
    // 搜索
    onSearch() {
      this.clearData()
      this.selectProductList()
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.clearData()
      this.pageSize = e
      this.selectProductList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.selectProductList()
    },
    // 图片预览
    previewImage(url) {
      this.imgList = url || []
      this.showViewer = true
    },
  },
}
</script>

<style lang="scss" scoped>
.main {

  .busilicense {
    display: block;
    width: 80px;
    height: 58px;
    border-radius: 4px;
  }

  .show_img {
    color: #1777d8;
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }
  }
}
</style>
